import { useEffect, useState } from "react";
import { useAppoitmentStatusList } from "@/app/hooks/api_hooks/dayClosing/useAppoitmentStatusList";
import { useLoader } from "@/app/hooks/useLoader";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import TableSkeletonComponent from "@/app/components/ui/LoaderComponent";
import { CiFlag1 } from "react-icons/ci";
import OverDueModalComponent from "../OverDueModalComponent";
import PetName from "@/app/components/ui/Reusable/PetName";
import Species from "@/app/components/ui/Reusable/Species";
import { useUtils } from "@/app/hooks/useUtils";
import Username from "@/app/components/ui/Reusable/Username";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useNewCartAPI } from "@/app/hooks/api_hooks/Cart/useNewCartAPI";

const PaymentsClosingComponent = () => {
  const { execute: fetchDayClosingData, closureData } = useAppoitmentStatusList();

  const queryParams = new URLSearchParams(location.search);
  const isLoading = useLoader("isClosingDataInProgress");
  const { NO_APPOINTMENTS } = useImageConstants();

  const { statusChipPWL, convertToReadableFormat } = useUtils();
  const mappedClinicID = useAppSelector((state) => state?.root?.UIStates?.mappedClinicId ?? "");
  const mappedClinicName = useAppSelector((state) => state.root?.UIStates?.mappedClinicName);

  const { execute: createNewCart } = useNewCartAPI();

  const [examption, setExamption] = useState(false);
  const [paymentDetails, setPpaymentDetails] = useState(null);

  // ✅ read query params
  const processId = queryParams.get("closing_process") ?? "";
  const queryCity = queryParams.get("city_id");
  const queryClinics = queryParams.get("clinic_ids");
  const queryShift = queryParams.get("shift") ?? "day";
  const time = queryParams.get("t") ?? "";

  useEffect(() => {
    if (queryClinics && queryClinics.length > 0 && queryShift) {
      fetchDayClosingData(queryClinics, queryShift, "appointments", "payment");
    }
  }, [processId, queryCity, queryClinics, queryShift, time]);
  const formatStatusLabel = (status?: string) => (status ? convertToReadableFormat(status) : "-");
  const clinicsWithPayments = closureData?.filter((clinic) => clinic?.closure_list?.length > 0) || [];

  const handelGoTocart = (wl: any) => {
    const petid = wl?.pet_details?.length > 0 && wl?.pet_details[0]?.id;
    createNewCart(wl?.user_details?.id, mappedClinicID, mappedClinicName).then(({ cart_id }) => {
      if (cart_id) {
        window.open(
          `/app/user-cart/cart-creation/${wl?.user_details?.id}/${cart_id}?from_cart=true&&pet_id=${petid}`,
          "_blank",
        );
      }
    });
  };
  return (
    <div className="w-full">
      {isLoading ? (
        <TableSkeletonComponent columnLength={6} />
      ) : clinicsWithPayments.length > 0 ? (
        <div className="space-y-3 overflow-y-auto max-h-[650px]">
          {clinicsWithPayments.map((clinic) => (
            <div key={clinic.clinic_id} className="rounded-2xl border border-[#ECEEF2] bg-white p-3 shadow-sm">
              <div className="overflow-x-auto rounded-xl">
                <table className="w-full min-w-[1200px] border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
                  <thead className="bg-[#F5F5F5] text-[#1F1F23] text-xs font-normal">
                    <tr>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Client Name</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Pet Details</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Appointment Status</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Payment Due</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Payment Status</th>
                      <th className="p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black capitalize tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="text-xs">
                    {clinic?.closure_list?.map((invoice, rowIndex) => {
                      const isFirst = rowIndex === 0;
                      const isLast = rowIndex === clinic.closure_list.length - 1;
                      const isSingle = clinic.closure_list.length === 1;

                      return (
                        <tr
                          key={invoice.invoice_id}
                          className={`
                            bg-white hover:bg-[#FCFCFD] transition-colors
                            ${isSingle ? "rounded-xl" : ""}
                            ${isFirst && !isSingle ? "rounded-t-xl" : ""}
                            ${isLast && !isSingle ? "rounded-b-xl" : ""}
                          `}
                        >
                          <td
                            className={`
                              p-3 text-xs text-blue-600
                              ${isSingle ? "rounded-tl-2xl rounded-bl-2xl" : ""}
                              ${isFirst && !isSingle ? "rounded-tl-2xl" : ""}
                              ${isLast && !isSingle ? "rounded-bl-2xl" : ""}
                            `}
                          >
                            <Username
                              username={invoice.user_details?.name}
                              petId={invoice.pet_details?.length > 0 && invoice.pet_details[0].id}
                              userId={invoice.user_details?.id}
                            />
                          </td>
                          <td className="p-3 text-xs">
                            {invoice?.pet_details?.length === 1 ? (
                              <div className="flex flex-col gap-1">
                                <PetName petName={invoice.pet_details[0]?.name} className="text-xs" petStatus="" />
                                <Species
                                  speciesId={invoice.pet_details[0]?.pet_species_type_id}
                                  className="text-[#6C727F] text-xs"
                                />
                              </div>
                            ) : (
                              invoice?.pet_details?.map((pet, index) => (
                                <div key={index} className="flex flex-col gap-1">
                                  <PetName petName={pet?.name} className="text-xs" petStatus="" />
                                  <Species speciesId={pet?.pet_species_type_id} className="text-[#6C727F] text-xs" />
                                </div>
                              ))
                            )}
                          </td>
                          <td className="p-3 text-xs">
                            {invoice?.booking_status ? (
                              <span className={statusChipPWL(formatStatusLabel(invoice?.booking_status))}>
                                {formatStatusLabel(invoice?.booking_status)}
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="p-3 text-xs whitespace-nowrap">{invoice?.invoice_details?.due_amount ?? "-"}</td>
                          <td className="p-3 text-xs">
                            {invoice?.invoice_details?.invoice_status ? (
                              <span className={statusChipPWL(formatStatusLabel(invoice?.invoice_details?.invoice_status))}>
                                {formatStatusLabel(invoice?.invoice_details?.invoice_status)}
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>

                          {!invoice.closure_status ? (
                            <td
                              className={`
                                p-3 text-xs w-[230px]
                                ${isSingle ? "rounded-tr-2xl rounded-br-2xl" : ""}
                                ${isFirst && !isSingle ? "rounded-tr-2xl" : ""}
                                ${isLast && !isSingle ? "rounded-br-2xl" : ""}
                              `}
                            >
                              {invoice?.invoice_details?.due_amount >= 0 ? (
                                <div className="flex flex-row items-center gap-3">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      window.open(
                                        `/app/user-cart/cart-billing/${invoice.user_details?.id}?from_cart=true`,
                                        "_blank",
                                      );
                                    }}
                                    className="bg-black px-4 py-2 w-[150px] justify-center text-center rounded-lg text-xs text-white font-medium whitespace-nowrap hover:opacity-90 transition-opacity"
                                  >
                                    Go to payment
                                  </button>
                                  <button
                                    className="flex items-center justify-center text-xs gap-2 text-[#FF0027] font-medium whitespace-nowrap"
                                    onClick={() => {
                                      setPpaymentDetails(invoice);
                                      setExamption(true);
                                    }}
                                  >
                                    <CiFlag1 className="w-4 h-4" />
                                    Raise Overdue
                                  </button>
                                </div>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => {
                                    handelGoTocart(invoice);
                                  }}
                                  className="bg-black px-4 py-2 w-[100px] justify-center text-center rounded-lg text-xs text-white font-medium whitespace-nowrap hover:opacity-90 transition-opacity"
                                >
                                  Go to cart
                                </button>
                              )}
                            </td>
                          ) : (
                            <td
                              className={`
                                p-3 text-xs
                                ${isSingle ? "rounded-tr-2xl rounded-br-2xl" : ""}
                                ${isFirst && !isSingle ? "rounded-tr-2xl" : ""}
                                ${isLast && !isSingle ? "rounded-br-2xl" : ""}
                              `}
                            />
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <NoDataFoundComponent imageURL={NO_APPOINTMENTS} message="No Invoices Found" />
      )}
      {examption && <OverDueModalComponent open={examption} setOpen={setExamption} paymentDetails={paymentDetails} />}
    </div>
  );
};

export default PaymentsClosingComponent;
